import { useEffect, useState } from 'react';
import { getAppointments } from '@general/api/onSchedAPI';

const useOnSchedAppointments = ({
    onSchedAPIToken,
    onSchedLocationID,
    onSchedResourceID,
    onSchedServiceID,
    startDate,
    endDate,
    APPOINTMENT_TIME_SLOT,
}) => {
    const [onSchedAppointments, setOnSchedAppointments] = useState(null);

    useEffect(() => {
        (async () => {
            const {
                data: { data: appointments },
            } = await getAppointments({
                apiToken: onSchedAPIToken,
                locationId: onSchedLocationID,
                resourceId: onSchedResourceID,
                serviceId: onSchedServiceID,
                startDate,
                endDate,
                // startDate: formatDateInEastern(event.meeting_start_time, 'yyyy-MM-dd'),
                // endDate: formatDateInEastern(event.meeting_end_time, 'yyyy-MM-dd'),
            });

            setOnSchedAppointments(
                appointments.map(appointment => ({
                    type: APPOINTMENT_TIME_SLOT,
                    title: `Appointment with ${appointment.name}`,
                    startDateTime: new Date(appointment.startDateTime),
                    endDateTime: new Date(appointment.endDateTime),
                }))
            );
        })();
    }, [
        onSchedAPIToken,
        onSchedLocationID,
        onSchedResourceID,
        onSchedServiceID,
        startDate,
        endDate,
        APPOINTMENT_TIME_SLOT,
    ]);

    return onSchedAppointments;
};

export default useOnSchedAppointments;
